import { RouterProvider } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer/Footer';

import Header from './components/Header/Header';
import Home from './components/Home/Home';
import router from './router/Router';

function App() {
  return (
    <>
      <div>
        <RouterProvider router={router}>
          <Header></Header>
          <main className='main'>
            <Home></Home>

          </main>
          <Footer></Footer>
        </RouterProvider>
      </div>
    </>
  );
}

export default App;
